import { attr, hasMany } from 'spraypaint';
import BaseApplicationRecord from './ApplicationRecord';

const Tag = BaseApplicationRecord.extend({
  attrs: {
    name: attr(),
    description: attr(),
    background_colour: attr(),
    text_colour: attr(),
    system_code: attr(),
    priority: attr(),
    sort_order: attr(),
    recipes: hasMany({
      type: 'recipes-recipes',
      persist: false,
    }),

  },
  static: {
    endpoint: '/tags',
    jsonapiType: 'tags-tags',
  },
});

export default Tag;
